import React from 'react'
import { FieldProps } from 'formik'

export function FormInput({ field, form: { errors, touched }, ...props }: FieldProps) {
    const name = field.name

    return (
        <input
            id={name}
            {...field}
            {...props}
            className="h-[44px] text-base text-grey100 flex items-center bg-white shadow-none w-full py-3 px-[14px] border border-solid border-border rounded-lg outline-1 outline-blue50 focus-within:border-blue40 focus-visible:outline-none hover:bg-grey20 placeholder:text-grey80 disabled:bg-grey30"
            data-error={touched[name] && errors[name] ? 'true' : undefined}
        />
    )
}
